{
	"titleFirstPart": "Välkommen till",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Totalt lagrat kol"
}
